<summit-web-user-info
  [restfulServicesUrl]="environment.restfulService"
  [isProduction]="environment.isNotLocalhost"
  [webUser]="webUser"
  [accessLevel]="accessLevelEnum.EDIT_NO_ADMIN"
  [hasProducerAccount]="hasProducerAccount"
  [isRequestingNewAccount]="true"
  (isUserValid)="setUserValid($event)"
  (profileTypeChanged)="updateProfileType($event)">
</summit-web-user-info>

<!--Don't display this section until a ProfileType has been selected-->
@if(profileType) {
  <summit-web-user-accounts [profileType]="profileType"
                            [webUser]="webUser"
                            [accessLevel]="accessLevelEnum.EDIT_NO_ADMIN"
                            (hasProducerAccount)="hasProducerAccount = $event"
                            (hasUnsavedChanges)="setIsAdding($event)">
  </summit-web-user-accounts>
}

<div class="button-group">
    <button mat-flat-button color="primary" (click)="save()" [disabled]="hasAttemptedSubmit > 0 && (!canSave || webUser.pendingAccounts.length <= 0)">Submit</button>
    <button mat-stroked-button color="primary" (click)="goBack()" class="cancel-button" >Back</button>
    <div class="util-message-container" style="overflow: hidden">
      <util-message [displayType]="'INLINE'"
                    [message]="!canSave ?
                                saveDisabledMessage :
                                'You must add at least one account before attempting to Submit.'"
                    [messageType]="'WARNING'"
                    [animationTrigger]="hasAttemptedSubmit > 0 && (!canSave || webUser.pendingAccounts.length <= 0) ? 'INVALID' : 'VALID'"
                    [materialIconName]="'warning'">
      </util-message>
    </div>
  </div>

@if(isLoading) {
  <loading-animation [loadingMessage]="'Submitting...'"></loading-animation>
}

<util-message [displayType]="'SNACKBAR'"
              [message]="errorMessage"
              [animationTrigger]="errorMessage ? 'INVALID' : 'VALID'"
              [duration]="10000">
</util-message>
